import { getFolder } from "../api/folder.services.ts"
import type { FolderParent } from "../types/folder.types.ts"

const MAX_DEPTH = 8

/** Walks a folder's `parent` chain up to the root, root-first. `Folder.parent`
 * only carries its own immediate parent, so a multi-level breadcrumb needs
 * one request per level — acceptable for a Details-panel action, not a list. */
export const resolveFolderBreadcrumb = async (
  folderId: string
): Promise<FolderParent[]> => {
  const path: FolderParent[] = []
  let currentId: string | null = folderId

  for (let i = 0; i < MAX_DEPTH && currentId; i++) {
    const response = await getFolder(currentId)
    if (!response.ok || !response.data) break
    path.unshift({ id: response.data.id, name: response.data.name })
    currentId = response.data.parent?.id ?? null
  }

  return path
}
